import JsBridge from '@/assets/js/js-bridge'
import deviceUtils from './device'

export function inputLimit(reg) {
  return function(that, key) {
    const fn = Object.prototype.toString.call(that[key]) === "[object Number]" ? Number : String
    let value = that[key].toString()
    do {
      if (!reg.test(value)) {
        if (value.length > 0) {
          value = value.substr(0, value.length - 1)
          that[key] = fn(value)
        } else {
          return
        }
      }
    } while (!reg.test(value))
  }
}


export const inputLimitNormal = inputLimit(/^\S*$/)
export const inputLimitPhone = inputLimit(/^1[0-9]{0,10}$/)
export const inputLimitCreditCode = inputLimit(/^[0-9A-Z]{1,18}$/)
export const inputLimitBankCard = inputLimit(/^\d{1,19}$/)
export const inputLimitIDCard = inputLimit(/^[0-9]{1,17}[0-9X]?$/)

export function debounce(fn, delay = 1000, ...args) {
  const _this = this // call apply执行该防抖函数，保存_this
  let timer = null
  return function(..._args) {
    timer && clearTimeout(timer)
    timer = setTimeout(() => {
      // 如果返回的函数改变了this指向，就用该this，否则使用debounce的this
      fn.apply(_this, args.concat(_args))
    }, delay)
  }
}

// 判断是哪个APP，根据包名来判断
export function whatApp(shopType) {
  const type = deviceUtils.getBuName()
  if (shopType) return type === shopType
  return type
}

// 获取APP类型
export const APP_NAME_ENUM = {
  bill: "bill",
  boss: "boss",
  owner: "owner",
  producer: "producer",
  cashierManage: "cashierManage",
  wscManage: "wscManage",
}
export function whatAppName() {
  if (deviceUtils.getBuName() === 'pf') {
    return deviceUtils.getAppType()
  }
  return ""
}

export function isCashierEnv() {
  const userAgent = navigator.userAgent;

  return /(SenguoCashier)/.test(userAgent)
}

// 判断密码是否是8-16位数字加字母组合
export function isPasswordEffective(password) {
  let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/
  return reg.test(password)
}

// simpleStorage
const storeMap = {
  localStorage: localStorage,
  sessionStorage: sessionStorage,
}

/**
 * 简单本地缓存
 *
 * ### Example
 * ```js
 * import { SimpleStorage } from 'senguo-lodash'
 * const simpleDao = new SimpleStorage('__abc__', {defaultValue: 123})
 * ```
 *
 * @param key - 本地缓存的key.
 * @param options - 本地缓存配置
 */
export class SimpleStorage {
  key
  defaultValue
  store = localStorage

  constructor(key, options) {
    this.key = key
    this.initOptions(options)
  }

  initOptions(options) {
    if (options) {
      this.defaultValue = options.defaultValue
      this.store = storeMap[options.type || 'localStorage']
    }
  }

  /**
   * 返回缓存的key
   */
  get _key() {
    return this.key
  }

  /**
   * 写入值
   *
   * ### Example
   * ```js
   * simpleDao.setData(123)
   * ```
   *
   * @param value - 数据.
   */
  setData(value) {
    this.store.setItem(this._key, this.stringify(value))
  }

  /**
   * 读取值
   *
   * ### Example
   * ```js
   * simpleDao.getData()
   * ```
   *
   * @returns 返回读取的值.
   */
  getData() {
    const result = this.parse(this.store.getItem(this._key))
    if (result === null) {
      return this.defaultValue
    }
    return result
  }

  /**
   * 删除值
   *
   * ### Example
   * ```js
   * simpleDao.clear()
   * ```
   *
   * @returns 返回读取的值.
   */
  clear() {
    this.store.setItem(this._key, '')
  }

  stringify(val) {
    try {
      return JSON.stringify(val)
    } catch (e) {
      return ''
    }
  }

  parse(val) {
    if (val === null) return val

    try {
      return JSON.parse(val)
    } catch {
      return null
    }
  }
}

// 登录页面，隐私协议&是否登录过
export const loginStorageDao = new SimpleStorage('__passport_frontend_login_read_key__', {defaultValue: {
  hasLogin: false
}})

let isInitPrivacy = false
export function initPluginsWithPrivacy() {
  isInitPrivacy = true
  JsBridge.invokeMethod('initPluginsWithPrivacy')
}

export function checkIsNewPrivacy() {
  try {
    return typeof window.Assistant.initPluginAfterLogin === 'function'
  } catch (e) {
    return false
  }
}

// 获取极光推送ID
let jpushID = ''
export function getJPushID() {
  return new Promise((resolve) => {
    if (jpushID) return resolve(jpushID)
    
    if (isInitPrivacy) {
      JsBridge.invokeMethod('getJPushID', (val) => {
        jpushID = val
        resolve(val)
      })
    } else {
      resolve('')
    }
  })
}